import { FC } from "react";

export const TermsOfConditionsand: FC = () => {
  return (
    <>
    TERMS OF COMDITIONSAND
    </>
  )
}
